import React, { useState, useEffect } from 'react'
import 'styles/main.scss'
import Redirect from 'components/Redirect'
import SetExperiment from 'components/SetExperiment'
import AffiliateData from 'components/AffiliateData'
import SeoData from 'components/SeoData'
import AccessTokenProvider from 'providers/AccessToken'
import FormDataProvider from 'providers/FormData'
import DownloadAppLinks from 'components/DownloadAppLinks'
import { popularAndroidLinks } from 'utils/popularAndroidLinks'
import SearchByBlock from 'components/SearchByBlock'
import FooterCopyContent from 'components/FooterCopyContent'
import FooterLinks from 'components/FooterLinks'
import VenderScripts from 'components/VendorScripts'
import FbPixelToTarckPageView from 'components/FbPixelVendorScriptPageView'
import Footer from 'components/Footer'
import { getCookie } from 'utils/cookie'

const Layout = props => {
  const {
    data: {
      airtable: {
        data: {
          title,
          description,
          metatags,
          matrimonialDb,
          footer_text: footerText,
        },
      },
    },
  } = props

  const {
    data: {
      airtable: {
        fields: {
          domainLogo,
          metaImage,
          androidAppStore,
          iphoneAppStore,
          domainCountry,
        },
      },
    },
  } = props

  const [state, setState] = useState({
    revampViewBucket: '',
  })
  useEffect(() => {
    const revampViewBucket = getCookie('revampView')
    setState({ revampViewBucket })
  }, [])

  return (
    <AccessTokenProvider>
      <FormDataProvider>
        <Redirect />
        <SetExperiment domainCountry={domainCountry} />
        <VenderScripts />
        <FbPixelToTarckPageView />
        <AffiliateData />
        <SeoData
          title={title}
          description={description}
          keywords={metatags}
          domainLogo={domainLogo}
          metaImage={metaImage}
        />
        {props.children}
        {!['H'].includes(state.revampViewBucket) && (
          <>
            <DownloadAppLinks
              altTitlePrefix={matrimonialDb}
              androidAppStore={androidAppStore}
              iphoneAppStore={iphoneAppStore}
            />
            <SearchByBlock
              searchByData={popularAndroidLinks}
              containerText="Our Most Popular Android Apps"
            />
            <FooterCopyContent footerText={footerText} />
            <FooterLinks />
            <Footer />
          </>
        )}
      </FormDataProvider>
    </AccessTokenProvider>
  )
}

export default Layout
